import React, {useState} from "react";
import {useDispatch} from "react-redux";
import * as userActions from '../../../redux/User/actions';
import saveDiskIcon from '../../../assets/save-disk.png';
import Modal from "../../../components/Modal";
import Row from "../../../components/Row";

import './SaveListModal.scss';
import Button from "../../../components/Button";
import {isNullOrEmpty} from "../../../utils/general";
import Toaster from "../../../components/Toaster";

const SaveListModal = props => {
	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const {accountNames, excludedAccounts, fileName, vendor, onListSaved, onClose} = props;
	const dispatch = useDispatch();

	const saveList = () => {
		if(isNullOrEmpty(name)) {
			Toaster.showWarn("List name can not be empty.");
		}
		else {
			dispatch(userActions.saveList(name, description, accountNames, excludedAccounts, fileName, vendor, onListSaved));
		}
	};

	return (
		<Modal onClose={onClose}>
			<div className="save-list-container">
				<div className="save-list-title">Save List</div>
				<div className="save-list-subtitle">Save your list for future reference</div>

				<div><input placeholder="List name" onChange={e => setName(e.target.value)} value={name} className="save-list-input" /></div>

				<div><textarea placeholder="Description" onChange={e => setDescription(e.target.value)} value={description} className="save-list-input" rows={3} /></div>

				<Row style={{columnGap: '10px'}}>
					<Button type="success" width={80} leftIcon={saveDiskIcon} onClick={saveList}>Save</Button>
					<Button width={80} center onClick={onClose}>Cancel</Button>
				</Row>
			</div>
		</Modal>
	)
};

export default SaveListModal;
